import PartyDto from "../../PaymentContainerClient/dtos/PartyDto";

export default function getCreditorName(creditor: PartyDto): string {
    return creditor.name
        ? creditor.name
        : creditor.holder &&
          creditor.holder.firstName &&
          creditor.holder.lastName
        ? `${creditor.holder.firstName} ${creditor.holder.lastName}`
        : "-";
}
